import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageHeader from "../../Header";
import { galleryFetch } from "../../../services/api/Gallery";
import ImageModal from "./Model";
import type { GalleryImage } from "../../../types/gallery";

const GalleryPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  const [images, setImages] = useState<GalleryImage[]>([]);
  const [loading, setLoading] = useState(true);
  const [heading, setHeading] = useState("");

  const [selectedImage, setSelectedImage] = useState<GalleryImage | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchGallery = async () => {
      if (!slug) {
        setImages([]);
        setHeading("");
        setLoading(false);
        return;
      }

      try {
        const folderName = decodeURIComponent(slug);

        console.log("Slug:", slug);
        console.log("Folder:", folderName);

        const response = await galleryFetch(
          `storage-gallery/infrastructure/${folderName}`,
        );

        const apiImages = response?.data?.images || [];

        // Gallery/award -> award
        const headingName =
          response?.data?.folder?.split("/").pop() || folderName;

        setImages(apiImages);
        setHeading(headingName);

        console.log("ALL IMAGES:", apiImages);
        console.log("TOTAL IMAGES:", apiImages.length);
        console.log("HEADING:", headingName);
      } catch (error) {
        console.error("Gallery fetch error:", error);
        setImages([]);
        setHeading("");
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, [slug]);

  const handleNavigate = (index: number) => {
    if (index < 0 || index >= images.length) return;

    setCurrentIndex(index);
    setSelectedImage(images[index]);
  };

  return (
    <>
      <div className="min-h-screen bg-gray-50">
        <PageHeader
          title={heading.replace(/[-_]/g, " ")}
          slug={heading.replace(/[-_]/g, " ")}
        />

        <div className="max-w-7xl mx-auto p-2">
          <div className="mb-10">
            <h2 className="text-3xl font-bold text-slate-800 capitalize">
              {heading ? heading.replace(/[-_]/g, " ") : "Explore Our Gallery"}
            </h2>

            <div className="w-20 h-1 bg-yellow-400 rounded-full mt-3" />
          </div>

          {loading ? (
            <div className="text-center py-20">
              <p>Loading gallery...</p>
            </div>
          ) : images.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-gray-500">No gallery images found.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-4">
              {images.map((image, index) => (
                <div
                  key={`${image.url}-${index}`}
                  onClick={() => {
                    setCurrentIndex(index);
                    setSelectedImage(image);
                  }}
                  className="bg-white rounded-md shadow hover:shadow-xl transition overflow-hidden group cursor-pointer"
                >
                  <div className="overflow-hidden">
                    <img
                      src={image.url}
                      alt={image.name}
                      loading="lazy"
                      className="w-full h-full object-contain group-hover:scale-105 transition duration-300"
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <ImageModal
        image={selectedImage}
        images={images}
        currentIndex={currentIndex}
        onClose={() => setSelectedImage(null)}
        onNavigate={handleNavigate}
      />
    </>
  );
};

export default GalleryPage;
